/* E-poçt bildirişindəki link açılanda istifadəçi giriş etməmiş ola bilər.
   PrivateRoute getmək istədiyi ünvanı sessionStorage-a yazır, giriş uğurlu
   olandan sonra bura qayıdırıq — panel yerinə həmin müraciət açılır. */
export function hedefUnvan() {
  try {
    const h = sessionStorage.getItem('ems_hedef');
    sessionStorage.removeItem('ems_hedef');
    // Yalnız öz saytımızın daxili yolu qəbul edilir
    if (h && h.startsWith('/') && !h.startsWith('//')) return h;
  } catch {}
  return '/';
}
